export const StepsTransitionTimeMs = 700;
export const PrivacyPolicyLink = 'https://www.purpleocean.co/privacy';
export const CookiesAcceptedKey = 'acceptGDPRPopover';
export const CookiesBrowserGuidKey = 'browserGuid';
export const InputValidationDebounceMs = 1000;

export const OrderPriceUSD = window.config.videoReadingPrice || 10;
export const DefaultPriceUSD = window.config.defaultVideoReadingPrice;

export const HasOrderDiscount = DefaultPriceUSD !== OrderPriceUSD;

export const CardsAnimationDelayMs = window.config.cardsAnimationDelay || 2500;

export const QuestionLength = {
  Minimum: window.config.descriptionMinLength || 25,
  Maximum: window.config.descriptionMaxLength || 300
};

export const NicknameLength = {
  Minimum: 2,
  Maximum: 20
};
